import React from 'react'
import { Dropdown } from 'react-bootstrap'

import useTranslation from '@/Hooks/UseTranslation'

type TasksView = 'by_status' | 'by_month'

interface Props {
  activeView: TasksView
  onlyShowMine: boolean
  onlyShowMineDisabled?: boolean
  onChangeView: (view: TasksView) => void
  onToggleOnlyShowMine: () => void
}

const TasksViewMenu = ({
  activeView,
  onlyShowMine,
  onlyShowMineDisabled = false,
  onChangeView,
  onToggleOnlyShowMine,
}: Props) => {

  const { t } = useTranslation()

  const hasCustomView = activeView !== 'by_status' || onlyShowMine

  return (
    <Dropdown className="pl4-tasks-view-menu">
      <Dropdown.Toggle
        as="button"
        type="button"
        className={`btn btn-link btn-link-header pl4-tasks-action pl4-page-action--secondary ${hasCustomView ? 'active' : ''}`}
        aria-label={t('TASKS:ToolbarViewButton')}
        title={t('TASKS:ToolbarViewButton')}
      >
        <span className="icon-orden_estado" aria-hidden="true" />
        <span className="d-none d-sm-inline">{t('TASKS:ToolbarViewButton')}</span>
        {onlyShowMine && <span className="pl4-tasks-view-menu__indicator" aria-hidden="true" />}
      </Dropdown.Toggle>

      <Dropdown.Menu alignRight className="pl4-tasks-view-menu__menu">
        <div className="pl4-tasks-view-menu__label">{t('TASKS:ToolbarGroupByLabel')}</div>
        <Dropdown.Item
          as="button"
          className="pl4-tasks-view-menu__item"
          role="menuitemradio"
          aria-checked={activeView === 'by_status'}
          onClick={() => onChangeView('by_status')}
        >
          <span className={`pl4-tasks-view-menu__selection ${activeView === 'by_status' ? 'active' : ''}`} aria-hidden="true" />
          <span>{t('TASKS:ToolbarGroupByStatus')}</span>
        </Dropdown.Item>
        <Dropdown.Item
          as="button"
          className="pl4-tasks-view-menu__item"
          role="menuitemradio"
          aria-checked={activeView === 'by_month'}
          onClick={() => onChangeView('by_month')}
        >
          <span className={`pl4-tasks-view-menu__selection ${activeView === 'by_month' ? 'active' : ''}`} aria-hidden="true" />
          <span>{t('TASKS:ToolbarGroupByMonth')}</span>
        </Dropdown.Item>

        <Dropdown.Divider />
        <div className="pl4-tasks-view-menu__label">{t('TASKS:ToolbarTasksLabel')}</div>
        <Dropdown.Item
          as="button"
          className="pl4-tasks-view-menu__item"
          role="menuitemcheckbox"
          aria-checked={onlyShowMine}
          disabled={onlyShowMineDisabled}
          onClick={onToggleOnlyShowMine}
        >
          <span className={`pl4-tasks-view-menu__check ${onlyShowMine ? 'active' : ''}`} aria-hidden="true">
            {onlyShowMine && <i className="fas fa-check" />}
          </span>
          <span>{t('TASKS:ToolbarOnlyMyTasks')}</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default TasksViewMenu
